var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-747.000000, -362.000000)",
    fill: "#FFFFFF",
    stroke: "#1E1E1E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(748.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Settings_Active",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,9.14782609 L16,6.76521739 L14.6086957,6.66434783 C14.0502713,6.6235513 13.5628209,6.27075478 13.3495652,5.75304348 L13.3495652,5.73565217 C13.1342852,5.21774957 13.2298748,4.62268522 13.5965252,4.19826087 L14.5078261,3.15478261 L12.813913,1.4573913 L11.7704348,2.36869565 C11.3460104,2.7353447 10.7509461,2.83093183 10.2330435,2.61565217 L10.2156522,2.61565217 C9.70011826,2.41108661 9.34637913,1.93043374 9.30434783,1.37739096 L9.18956522,0 L6.80695652,0 L6.70608696,1.37043478 C6.66466435,1.92616139 6.31140522,2.4102087 5.79478261,2.61913148 L5.79478261,2.61913078 C5.27688,2.83441043 4.68181565,2.73882296 4.2573913,2.37217391 L3.21391304,1.46086991 L1.49913043,3.13043478 L2.41043478,4.17391304 C2.77708383,4.59833739 2.87267096,5.19340174 2.6573913,5.71130435 L2.65739096,5.71130435 C2.45567235,6.24746783 1.96234504,6.61881739 1.39130435,6.66434783 L0,6.76521739 L0,9.14782609 L1.39130435,9.25217391 C1.94973009,9.29297043 2.43717983,9.64576696 2.65043478,10.1634783 L2.65043478,10.1808696 C2.86571478,10.6987722 2.7701273,11.2938365 2.40347826,11.7182643 L1.49217391,12.7617391 L3.17565217,14.4452174 L4.21913043,13.533913 C4.64355478,13.1672661 5.23861913,13.07168 5.75652174,13.2869565 L5.77391304,13.2869565 C6.2943513,13.5100139 6.64619826,14.0055583 6.68521739,14.5704348 L6.80695652,16 L9.18956522,16 L9.29043478,14.5913043 C9.33137739,14.0304487 9.68345391,13.5399548 10.2017391,13.3217391 L10.2191304,13.3217391 C10.7363896,13.10552 11.3313878,13.1997496 11.7565252,13.5652174 L12.8,14.4730435 L14.4834783,12.786087 L13.5721739,11.7426087 C13.205527,11.3181843 13.1099374,10.72312 13.3252209,10.2052174 L13.3252209,10.1878261 C13.5349287,9.6530713 14.0354226,9.28821217 14.6086957,9.25217391 L16,9.14782609 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4347826,8 C10.4347826,9.34469217 9.34469217,10.4347826 8,10.4347826 C6.65530783,10.4347826 5.56521739,9.34469217 5.56521739,8 C5.56521739,6.65530783 6.65530783,5.56521739 8,5.56521739 C9.34469217,5.56521739 10.4347826,6.65530783 10.4347826,8 Z",
    id: "Stroke-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuSettingsActive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Settings_Active.cb1337aeb407ae26d3ca70ac82bf262c.svg";
export { ForwardRef as ReactComponent };